/**
 * @typedef {import('../../types').InputKinds} InputKinds
 * @typedef {import('../../types').Validation} Validation
 */

/**
 * Add two numbers.
 * @param {InputKinds} type type of input to validate
 * @param {number | string} value the value selected by the user
 * @param {Validation} validation validation object sent in the API request
 * @returns {{ isValid, key }} The sum of the two numbers.
 */
function validate(type, value, validation) {
  const {
    required = false,
    minLength = false,
    maxLength = false,
    correctResponses = [],
  } = validation;

  if (required && !value.length) {
    return {
      isValid: false,
      key: "required",
    };
  }

  const validateComponents = {
    checkboxes: () => {
      if (
        correctResponses?.length &&
        correctResponses?.sort().toString() !== value.sort().toString()
      ) {
        return {
          isValid: true,
          key: "incorrectResponses",
        };
      }
      if (
        correctResponses?.length &&
        correctResponses?.sort().toString() === value.sort().toString()
      ) {
        return {
          isValid: true,
          key: "correctResponses",
        };
      }
      return {
        isValid: true,
      };
    },
    radiobuttons: () => {
      if (correctResponses?.length && !correctResponses?.includes(value)) {
        return {
          isValid: false,
          key: "incorrectResponses",
        };
      }
      if (correctResponses?.length && correctResponses?.includes(value)) {
        return {
          isValid: true,
          key: "correctResponses",
        };
      }
      return {
        isValid: true,
      };
    },
    select: () => {
      if (value === "initial" && required) {
        return {
          isValid: false,
          key: "required",
        };
      }
      if (correctResponses?.length && !correctResponses?.includes(value)) {
        return {
          isValid: false,
          key: "incorrectResponses",
        };
      }
      if (correctResponses?.length && correctResponses?.includes(value)) {
        return {
          isValid: true,
          key: "correctResponses",
        };
      }
      return {
        isValid: true,
      };
    },
    text: () =>
      // Not an actual form component
      ({
        isValid: true,
      }),
    textarea: () => {
      if (value.length === 0) {
        return {
          isValid: false,
          key: "required",
        };
      }
      if (minLength && value.length < minLength) {
        return {
          isValid: false,
          key: "minLength",
        };
      }
      /** Test for maximum length. */
      if (maxLength && value.length > maxLength) {
        return {
          isValid: false,
          key: "maxLength",
        };
      }
      return {
        isValid: true,
      };
    },
    textfield: () => {
      if (value.length === 0) {
        return {
          isValid: false,
          key: "required",
        };
      }
      if (minLength && value.length < minLength) {
        return {
          isValid: false,
          key: "minLength",
        };
      }
      /** Test for maximum length. */
      if (maxLength && value.length > maxLength) {
        return {
          isValid: false,
          key: "maxLength",
        };
      }
      return {
        isValid: true,
      };
    },
  };
  if (!validateComponents[type]) {
    console.error(`Invalid component type: ${type}`);
    return null;
  }
  return validateComponents[type]();
}
export default validate;
